import { resource, RequestConfig } from '../helper/resource';

/**
 * 报价回购撤单操作
 */
export function cancelBjProdRequestUsingPOST(req: CancelBJProdRequstParam, config?: RequestConfig): Promise<ApiResult> {
  return resource.post('/lcmall/cancelBjProdRequest', req, config);
}

/**
 * 产品预约撤单操作
 */
export function cancelFundProdAppointmentRequestUsingPOST(
  req: CancelFundProdRequstParam,
  config?: RequestConfig
): Promise<ApiResult> {
  return resource.post('/lcmall/cancelFundProdAppointmentRequest', req, config);
}

/**
 * 理财产品撤单操作
 */
export function cancelFundProdRequestUsingPOST(
  req: CancelFundProdRequstParam,
  config?: RequestConfig
): Promise<ApiResult> {
  return resource.post('/lcmall/cancelFundProdRequest', req, config);
}

/**
 * 获取报价回购产品详情信息
 */
export function getBJDetailInfoUsingPOST(
  req: BJDetailInfoParam,
  config?: RequestConfig
): Promise<ApiResultBuyBackInfoDto> {
  return resource.post('/lcmall/getBJDetailInfo', req, config);
}

/**
 * [No Auth]获取系统当前时间
 */
export function getCurrentTimeUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcmall/getCurrentTime', req, config);
}

/**
 * 计算产品赎回预计到账时间
 */
export function getPredictAvailableDateUsingPOST(
  req: CalculateDateParam,
  config?: RequestConfig
): Promise<ApiResultstring> {
  return resource.post('/lcmall/getPredictAvailableDate', req, config);
}

/**
 * 查询产品代码信息详情
 */
export function getProductDetailInfoUsingPOST(
  req: ProductDetailInfoParam,
  config?: RequestConfig
): Promise<ApiResultProdcutInfoDto> {
  return resource.post('/lcmall/getProductDetailInfo', req, config);
}

/**
 * loadMappingToRedis--刷新redis缓存数据
 */
export function loadMappingToRedisUsingPOST(req: void, config?: RequestConfig): Promise<ApiResult> {
  return resource.post('/lcmall/loadMappingToRedis', req, config);
}

/**
 * 查询定投天数
 */
export function queryAutoInvestDaysUsingPOST(
  req: InvestPlanListParam | void,
  config?: RequestConfig
): Promise<ApiResultAutoInvestDaysDto> {
  return resource.post('/lcmall/queryAutoInvestDays', req, config);
}

/**
 * 查询某产品定投交易记录
 */
export function queryAutoInvestDetailRecordsUsingPOST(
  req: PeriodInvestRecordsListParam,
  config?: RequestConfig
): Promise<ApiResultListTransRecordListDto> {
  return resource.post('/lcmall/queryAutoInvestDetailRecords', req, config);
}

/**
 * 查询定投计划列表
 */
export function queryAutoInvestPlanUsingPOST(
  req: InvestPlanListParam | void,
  config?: RequestConfig
): Promise<ApiResultListInvestPlanListDto> {
  return resource.post('/lcmall/queryAutoInvestPlan', req, config);
}

/**
 * 查询历史成交信息
 */
export function queryHistoryDealInfoUsingPOST(
  req: HistoryDealInfoParam,
  config?: RequestConfig
): Promise<ApiResultHistoryDealInfoDto> {
  return resource.post('/lcmall/queryHistoryDealInfo', req, config);
}

/**
 * 查询某定投计划详情
 */
export function querySingleAutoInvestDetailUsingPOST(
  req: SingleAutoInvestDetailParam,
  config?: RequestConfig
): Promise<ApiResultInvestPlanListDto> {
  return resource.post('/lcmall/querySingleAutoInvestDetail', req, config);
}

/**
 * 查询单个产品交易记录
 */
export function querySingleProdTransRecordListUsingPOST(
  req: SingleProdTransRecordListParam,
  config?: RequestConfig
): Promise<ApiResultListTransRecordListDto> {
  return resource.post('/lcmall/querySingleProdTransRecordList', req, config);
}

/**
 * 查询收益凭证交易记录详情到期收益
 */
export function querySypzMaturityIncomeUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/lcmall/querySypzMaturityIncome', req, config);
}

/**
 * 查询交易记录
 */
export function queryTransactionRecordListUsingPOST(
  req: TransRecordListParam,
  config?: RequestConfig
): Promise<ApiResultListTransRecordListDto> {
  return resource.post('/lcmall/queryTransactionRecordList', req, config);
}
